import React, { useState } from 'react';
import Layout from './Layout';
  

const Reports = () => {
  const [reportType, setReportType] = useState('Users Report');
  const [exportFormat, setExportFormat] = useState('CSV');

  const recentReports = [
    {
      name: 'Payments_Report_June2025.pdf',
      type: 'Payments',
      date: '2025-06-15 14:30',
      status: 'Ready',
    },
    {
      name: 'Users_Report_June2025.csv',
      type: 'Users',
      date: '2025-06-15 13:15',
      status: 'Processing',
    },
    {
      name: 'Revenue_Summary_June2025.pdf',
      type: 'Revenue',
      date: '2025-06-15 12:00',
      status: 'Failed',
    },
  ];

  const getStatusStyle = (status) => {
    if (status === 'Ready') return 'text-green-600 bg-green-100';
    if (status === 'Processing') return 'text-yellow-700 bg-yellow-100';
    if (status === 'Failed') return 'text-red-600 bg-red-100';
  };

  return (
  <div className="min-h-screen ">
          <div className="mb-6 md:mb-6">
            <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Download Reports</h1>
            <p className="text-gray-600 mt-2">    Quickly download your medical and session reports in one place.</p>
</div>

          {/* Form */}
    <div className="bg-white rounded-xl shadow p-6 mb-10">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

  {/* Report Type */}
  <div>
    <label className="text-xs text-gray-500">Select Report Type</label>
    <div className="relative w-full">
      <select
        value={reportType}
        onChange={(e) => setReportType(e.target.value)}
        className="w-full appearance-none border mt-1 px-3 py-2 pr-10 rounded-lg bg-white text-sm text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option>Users Report</option>
        <option>Payments Report</option>
        <option>Revenue Report</option>
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
        <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  </div>

  {/* Date Range */}
<div className="flex flex-col sm:flex-row gap-4">
  <div className="w-full mt-7">
   
     <div className="relative">
      <input
        type="text"
        placeholder="Select date range"
        className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    </div>
  </div>
  {/* <div className="w-full">
    <label className="text-xs text-gray-500">End Date</label>
    <div className="relative">
      <input
        type="text"
        placeholder="Select date range"
        className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    </div>
  </div> */}
</div>

  {/* User Role */}
  <div>
    <label className="text-xs text-gray-500">User Role (Optional)</label>
    <div className="relative w-full">
      <select className="w-full appearance-none border mt-1 px-3 py-2 pr-10 rounded-lg bg-white text-sm text-black focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option>All Roles</option>
        <option>Admin</option>
        <option>Editor</option>
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
        <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  </div>

  {/* Export Format */}
  <div>
    <label className="text-xs text-gray-500">Export Format</label>
    <div className="relative w-full">
      <select
        value={exportFormat}
        onChange={(e) => setExportFormat(e.target.value)}
        className="w-full appearance-none border mt-1 px-3 py-2 pr-10 rounded-lg bg-white text-sm text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option>CSV</option>
        <option>PDF</option>
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
        <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  </div>

</div>


  {/* Button */}
  <button className="mt-4 bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 w-full sm:w-auto">
    Generate Report
  </button>
</div>


   
<div className="w-full">
  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Recent Reports</h2>

  {/* Mobile version (stacked cards) */}
  <div className="md:hidden space-y-4">
    {recentReports.map((report, idx) => (
      <div
        key={idx}
        className="bg-white border border-gray-100 rounded-xl shadow-sm p-4 space-y-2"
      >
        <div className="text-sm font-medium text-gray-800">
          <span className="block text-xs text-gray-500">Report Name:</span>
          {report.name}
        </div>
        <div className="text-sm text-gray-600">
          <span className="block text-xs text-gray-500">Type:</span>
          {report.type}
        </div>
        <div className="text-sm text-gray-600">
          <span className="block text-xs text-gray-500">Date Generated:</span>
          {report.date}
        </div>
        <div>
          <span className="block text-xs text-gray-500">Status:</span>
          <span
            className={`px-3 py-1 rounded-full text-xs font-medium inline-block ${getStatusStyle(report.status)}`}
          >
            {report.status}
          </span>
        </div>
        <div>
          <button className="text-blue-600 border border-blue-500 px-4 py-1 text-sm rounded hover:bg-blue-50">
            Download
          </button>
        </div>
      </div>
    ))}
  </div>

  {/* Desktop/tablet version */}
  <div className="hidden md:block overflow-x-auto">
    <div className="min-w-[768px]">
      {/* Header */}
      <div className="grid grid-cols-5 gap-4 items-center text-xs bg-gray-100 font-medium text-gray-600 uppercase tracking-wider mb-4 px-4 py-4 rounded-md">
        <div>Report Name</div>
        <div>Type</div>
        <div>Date Generated</div>
        <div>Status</div>
        <div>Download</div>
      </div>

      {/* Rows */}
      <div className="space-y-2">
        {recentReports.map((report, idx) => (
          <div
            key={idx}
            className="grid grid-cols-5 gap-4 items-center bg-white border rounded-xl px-4 py-3 shadow-sm hover:bg-blue-50 transition border-gray-200 hover:border-blue-300"
          >
            <div className="text-sm text-gray-800 font-medium truncate">{report.name}</div>
            <div className="text-sm text-gray-600">{report.type}</div>
            <div className="text-sm text-gray-600">{report.date}</div>
            <div>
              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusStyle(report.status)}`}
              >
                {report.status}
              </span>
            </div>
            <div>
              <button className="text-blue-600 border border-blue-500 px-4 py-1 text-sm rounded hover:bg-blue-50 whitespace-nowrap">
                Download
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>

       
     </div>
  );
};

export default Reports;
